import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetchMe, logout as apiLogout } from "./api";

const AuthCtx = createContext(null);

const GOOGLE_LOGIN_ENABLED =
  (process.env.REACT_APP_ENABLE_GOOGLE_LOGIN || "false").toLowerCase() === "true";
const GOOGLE_AUTH_URL = (process.env.REACT_APP_GOOGLE_AUTH_URL || "").trim();
const GOOGLE_LOGIN_AVAILABLE = GOOGLE_LOGIN_ENABLED && Boolean(GOOGLE_AUTH_URL);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const me = await fetchMe();
      setUser(me);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash && window.location.hash.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  const logout = async () => {
    try { await apiLogout(); } catch {}
    setUser(null);
  };

  const login = () => {
    if (!GOOGLE_LOGIN_AVAILABLE) {
      window.location.assign("/login");
      return;
    }

    const redirectUrl = window.location.origin + "/";
    const separator = GOOGLE_AUTH_URL.includes("?") ? "&" : "?";
    window.location.href =
      `${GOOGLE_AUTH_URL}${separator}redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <AuthCtx.Provider
      value={{
        user,
        loading,
        login,
        logout,
        refresh,
        setUser,
        googleLoginAvailable: GOOGLE_LOGIN_AVAILABLE,
      }}
    >
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
